// extracted by mini-css-extract-plugin
module.exports = {"Input":"Input_Input__2lZSr","Label":"Input_Label__vo3TC","InputElement":"Input_InputElement__10mye","Invalid":"Input_Invalid__1NvXB"};